import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { residentConfirmPresentation } from "@/features/resident/constants/residentDialogProps";
import { REIMBURSEMENT_MILESTONE_LABELS } from "../../utils/reimbursementMilestoneStatus";

export interface ReimbursementSectionSubmitConfirmProps {
  pendingMilestoneId: number | null;
  onConfirm: (milestoneId: number) => void;
  onDismiss: () => void;
}

export function ReimbursementSectionSubmitConfirm({
  pendingMilestoneId,
  onConfirm,
  onDismiss,
}: ReimbursementSectionSubmitConfirmProps) {
  const pendingMilestoneLabel =
    pendingMilestoneId != null &&
    (pendingMilestoneId === 1 ||
      pendingMilestoneId === 2 ||
      pendingMilestoneId === 3)
      ? REIMBURSEMENT_MILESTONE_LABELS[pendingMilestoneId]
      : "Section";

  return (
    <ConfirmDialog
      isOpen={pendingMilestoneId !== null}
      title={`Submit ${pendingMilestoneLabel}`}
      message={`This will lock the ${pendingMilestoneLabel} section and no further changes can be made.\n\nDo you want to continue?`}
      messageLayout="listingConfirm"
      messageAlign="left"
      messageWeight="normal"
      saveChangesWidth="comfortable"
      titleClassName="!text-[17px] sm:!text-[18px] !font-bold !leading-snug !whitespace-nowrap max-[400px]:!whitespace-normal max-[400px]:!text-base"
      primaryLabel="Yes"
      secondaryLabel="No"
      onPrimary={() => {
        const milestoneId = pendingMilestoneId;
        onDismiss();
        if (milestoneId != null) {
          onConfirm(milestoneId);
        }
      }}
      onSecondary={onDismiss}
      onDismiss={onDismiss}
      overlayDataTestId="reimbursement-section-submit-confirm"
      primaryButtonDataTestId="reimbursement-section-submit-confirm-yes"
      secondaryButtonDataTestId="reimbursement-section-submit-confirm-no"
      {...residentConfirmPresentation}
    />
  );
}
